export const KINDRED_OPTIONS = [
  {
    id: "dragons",
    name: "Dragons",
    description: "Rule the skies with powerful dragons",
    creatureType: "Dragon",
    colorIdentity: ['W', 'U', 'B', 'R', 'G']
  },
  {
    id: "zombies",
    name: "Zombies",
    description: "Overwhelm your opponents with a horde of undead",
    creatureType: "Zombie",
    colorIdentity: ['U', 'B']
  },
  {
    id: "elves",
    name: "Elves",
    description: "Build up a massive army of elves and overrun your foes",
    creatureType: "Elf",
    colorIdentity: ['G']
  },
  {
    id: "merfolk",
    name: "Merfolk",
    description: "Control the seas with a school of merfolk",
    creatureType: "Merfolk",
    colorIdentity: ['U']
  },
  {
    id: "vampires",
    name: "Vampires",
    description: "Drain your opponents' life with an army of vampires",
    creatureType: "Vampire",
    colorIdentity: ['B', 'R']
  },
  {
    id: "dinosaurs",
    name: "Dinosaurs",
    description: "Unleash prehistoric fury with giant dinosaurs",
    creatureType: "Dinosaur",
    colorIdentity: ['G', 'W', 'R']
  },
  {
    id: "squirrels",
    name: "Squirrels",
    description: "Overrun your opponents with a swarm of squirrels",
    creatureType: "Squirrel",
    colorIdentity: ['B', 'G']
  },
  {
    id: "unicorns",
    name: "Unicorns",
    description: "Heal and protect your creatures with a herd of unicorns",
    creatureType: "Unicorn",
    colorIdentity: ['G', 'W']
  }
];

export const buildQueryItem = (query: string) => { 
  return query.startsWith('/') ? `(o:${query})` : `(t:"${query}" or o:"${query}")`;
}

export const buildKindredQuery = (colorIdentity: string[], creatureType: string, commanderQuery = false) => {
  let query = `f:edh game:paper `;
  
  if (commanderQuery) {
    query += `is:commander `;
  }
  if (colorIdentity.length > 0) query += `${commanderQuery ? 'ci=' : 'ci:'}${colorIdentity.join('')} `
  const queries = [
    `(t:${creatureType} or o:${creatureType})`,
    `o:/${creatureType}s? you control/`,
    `o:'${creatureType} cards'`,
    `o:'search your library for a ${creatureType}'`,
    `o:/${creatureType}( creature)? spell(s)?/`,
    `o:/whenever (a|another nontoken) ${creatureType} you control/`
  ];
  query += ` (${queries.join(' or ')})`;

  return query;
}

export const buildSimpleQuery = (colorIdentity: string[], themes: string, cardTypes: string[], creatureTypes: string[], commanderQuery = false) => {
  let query = 'f:edh game:paper';
  
  if (colorIdentity.length > 0) {
    const ciOperator = commanderQuery ? 'ci=' : 'ci:';
    query += ` ${ciOperator}${colorIdentity.join('')}`;
  }
  
  // Build theme query
  const allThemes: string[] = [];
  const requiredThemes: string[] = [];

  // If it's a Kindred deck, the creature type is a required theme
  if (creatureTypes.length > 0) {
    creatureTypes.forEach(type => {
      requiredThemes.push(`(t:${type} or o:${type})`);
    });
  }

  cardTypes.forEach(type => {
    if (type) allThemes.push(buildQueryItem(type));
  })
  
  if (themes) {
    const themeParts = themes.split(',').map(t => t.trim()).filter(t => t);
    themeParts.forEach(theme => {
      if (theme) {
        if (theme.startsWith('cmc') || theme.startsWith('power')) {
          requiredThemes.push(theme);
        } else {
          allThemes.push(buildQueryItem(theme));
        }
      }
    });
  }

  if (allThemes.length > 0)
    query += ` (${allThemes.join(' or ')})`;
  if (requiredThemes.length > 0)
    query += ` ${requiredThemes.join(' ')}`
  
  return query;
};